import * as React from "react";
const SvgIconCheckmarkSecondary = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 0, y1: 7, x2: 13, y2: 7, stroke: "white", strokeWidth: 3 }));
export default SvgIconCheckmarkSecondary;
